import React, { forwardRef } from 'react'

interface ISearchInputProps {
    id: string
    placeholder: string
    name?: string
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    value?: string
    dataTestId?: string
}

const SearchInput = forwardRef<HTMLInputElement, ISearchInputProps>((props, ref) => {
    return (
        <div className="col-xs-4">
            <div className="form-group">
                <input
                    ref={ref}
                    type="text"
                    placeholder={props.placeholder}
                    id={props.id}
                    className="form-control"
                    value={props.value}
                    name={props.name}
                    {...(props.onChange && { onChange: props.onChange })}
                    {...(props.dataTestId && { 'data-testid': props.dataTestId })}
                />
            </div>
        </div>
    )
})

export default SearchInput
